import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Adds a backToTop Button to the page after a certain amount of scrolling
 */
class BackToTopButton extends HtmlElement {

	/**
	 * Create the button and add it to the page
	 * it should be hidden per css at this point
	 * @returns {jQuery|HTMLElement}
	 */
	constructor() {
		// disable the element if backToTopButtonAt is less than 1
		if(Settings.backToTopButtonAt < 1) {
			// passing an empty object if there is no backToTopButton to prevent errors in HTMLElement
			return super({});
		}

		let button = $(document.createElement('div')),
			icon = $(document.createElement('i'));

		button.addClass('back-to-top-button');
		button.attr('aria-hidden', true);
		icon.addClass('fa fa-angle-up');

		button.append(icon);
		$body.append(button);

		// passing the actual button to HTMLElement after it was added to the page
		super(button);

		this.$element.on('click', (e) => {
			this.onClick(e)
		});

		this.visible = false;
	}

	onScroll() {
		this.toggleButton();
	}

	onResize() {
		this.toggleButton();
	}

	toggleButton() {
		let showButton = ($window.scrollTop() > Settings.backToTopButtonAt && $window.width() > Settings.backToTopButtonMinWidth);

		if(this.visible !== showButton) {
			this.$element.toggleClass('visible', showButton);
			this.visible = showButton;
		}
	}

	onClick(e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop : 0
		}, Settings.backToTopButtonAnimationDuration);
	}
}

export default (new BackToTopButton());